import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../constants/msal-config';

export const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
